import axios from './axios.js'

const baseURL = 'https://g.app.universalbeijingresort.com/'; // 生产
// const baseURL = 'https://tg.app.universalbeijingresort.com/test/'; // 测试
// const baseURL = 'https://eg.app.universalbeijingresort.com/uat/'; // uat

export const GetNewsList = (params) => {
  return axios.request({
    url: baseURL + 'h5/user_location',
    method: 'get',
    crossDomain: true, //设置跨域为true
    params: params,
  })
}
export const GetDownloadurl = (params) => {
  return axios.request({
    url: baseURL + 'h5/download/url',
    method: 'get',
    crossDomain: true, //设置跨域为true
    params: params,
  })
}
